export type Feature = keyof typeof features;

export const features = {
  OVERVIEW_UI: 'xxx',
  OPEX: '7c3bdd04-b331-4595-b383-1462ee2a452f',
  ACH: '0156bd9a-94d5-4396-b9e2-0584918fc298',
  SISS: 'd299abdc-0b88-47c5-b1d0-6aafc29e2428',
  CHAT_VRT: '17acff15-0f43-4d44-a78e-b74b9c8c4768',
  VR_SIDEKICK_CUTOVER: '6021149c-7741-4bc7-932a-3678b985fa96',
  VRP_ADVENT_PREVIEW: 'd07870d7-444c-4375-ae4f-40646765edca',
  EXTENSION_ECOSYSTEM_CONNECT_AIRBNB: '88e2e0fa-8567-4f8f-a90f-a10dbdd98592',
  FEES_V2: 'cd7f7b52-939f-49b0-99bd-2e2dbc40faf0',
  VRPILOT_ONGOING_TASKS: 'b98e8887-82b4-42a1-a45f-77c17784323f',
} as const;

/**
 * `/me.features` is the authoritative source for product feature gates: the
 * API returns the effective feature ids for the user on the resolved team.
 * Client-side rule: the spotlight `_UI` toggle.
 */
export const getEnabledFeatures = ({
  isV2,
  featureIds,
}: {
  isV2: boolean;
  featureIds: readonly string[];
}): Record<Feature, boolean> => {
  return Object.entries(features).reduce<Record<Feature, boolean>>(
    (acc, [key, value]) => {
      const featureKey = key as Feature;

      const isSpotlightV2_UI = featureKey.endsWith('_UI') && isV2;

      acc[featureKey] = isSpotlightV2_UI || featureIds.includes(value);

      return acc;
    },
    {} as Record<Feature, boolean>
  );
};
